if (!window.Eurus.loadedScript.includes('lp-ba.js')) {
    window.Eurus.loadedScript.push('lp-ba.js');
}
const deferScriptLoad = (name, src, onload, requestVisualChange = false) => {
    window.Eurus.loadedScript.push(name);
    (events => {
        const loadScript = () => {
            events.forEach(type => window.removeEventListener(type, loadScript));
            clearTimeout(autoloadScript);
            const initScript = () => {
                const script = document.createElement('script');
                script.setAttribute('src', src);
                script.setAttribute('defer', '');
                script.onload = () => {
                    document.dispatchEvent(new CustomEvent(name + ' loaded'));
                    onload();
                };
                document.head.appendChild(script);
            };
            if (requestVisualChange) {
                if (window.requestIdleCallback) {
                    requestIdleCallback(initScript);
                }
                else {
                    requestAnimationFrame(initScript);
                }
            }
            else {
                initScript();
            }
        };
        let autoloadScript;
        const wait = window.innerWidth > 767 ? 2000 : 5000;
        events.forEach(type => window.addEventListener(type, loadScript, { once: true, passive: true }));
        autoloadScript = setTimeout(() => {
            loadScript();
        }, wait);
    })(['touchstart', 'mouseover', 'wheel', 'scroll', 'keydown']);
};
// alpine func
requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
        Alpine.store('xSplide', {
            load(el, configs) {
                const initSlider = () => {
                    const id = el.getAttribute("id");
                    if (configs.classes != undefined) {
                        if (!configs.classes.arrow)
                            configs.classes.arrow = "arrow w-8 h-8 p-2 absolute z-10 top-1/2 -translate-y-1/2 hidden md:flex items-center justify-center";
                        if (!configs.classes.next)
                            configs.classes.next = "right-0";
                        if (!configs.classes.prev)
                            configs.classes.prev = "-rotate-180";
                    }
                    let splide = new Splide("#" + id, configs);
                    if (configs.thumbs) {
                        let thumbsRoot = document.getElementById(configs.thumbs);
                        let thumbs = thumbsRoot.getElementsByClassName('x-thumbnail');
                        let current;
                        let _this = this;
                        for (let i = 0; i < thumbs.length; i++) {
                            if (thumbs[i] == current) {
                                thumbs[i].classList.remove('opacity-30');
                            }
                            else {
                                thumbs[i].classList.add('opacity-30');
                            }
                            thumbs[i].addEventListener('click', function () {
                                _this.moveThumbnail(i, thumbs[i], thumbsRoot, configs.thumbs_direction, configs.direction);
                                splide.go(i);
                            });
                        }
                        splide.on('refresh', function () {
                            for (let i = 0; i < thumbs.length; i++) {
                                thumbs[i].removeEventListener('click', function () {
                                    _this.moveThumbnail(i, thumbs[i], thumbsRoot, configs.thumbs_direction, configs.direction);
                                    splide.go(i);
                                });
                            }
                            let thumbsRoot = document.getElementById(configs.thumbs);
                            let thumbsNew = thumbsRoot.getElementsByClassName('x-thumbnail');
                            for (let i = 0; i < thumbsNew.length; i++) {
                                if (i == 0) {
                                    thumbsNew[i].classList.remove('opacity-30');
                                }
                                else {
                                    thumbsNew[i].classList.add('opacity-30');
                                }
                                thumbsNew[i].addEventListener('click', function () {
                                    _this.moveThumbnail(i, thumbsNew[i], thumbsRoot, configs.thumbs_direction, configs.direction);
                                    splide.go(i);
                                });
                            }
                        });
                        splide.on('mounted move', function () {
                            let thumbnail = thumbs[splide.index];
                            if (thumbnail) {
                                if (current) {
                                    current.classList.add('opacity-30');
                                }
                                thumbnail.classList.remove('opacity-30');
                                current = thumbnail;
                                _this.moveThumbnail(splide.index, thumbnail, thumbsRoot, configs.thumbs_direction, configs.direction);
                            }
                        });
                    }
                    if (configs.hotspot) {
                        let hotspotRoot = document.getElementById(configs.hotspot);
                        let hotspots = hotspotRoot.getElementsByClassName('x-hotspot');
                        let current;
                        if (configs.disableHoverOnTouch && (('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints)) {
                            for (let i = 0; i < hotspots.length; i++) {
                                hotspots[i].addEventListener('click', function () {
                                    splide.go(i);
                                });
                            }
                        }
                        else {
                            for (let i = 0; i < hotspots.length; i++) {
                                hotspots[i].addEventListener('mouseover', function () {
                                    splide.go(i);
                                });
                                hotspots[i].addEventListener('focus', function () {
                                    splide.go(i);
                                });
                            }
                        }
                        splide.on('mounted move', function () {
                            let hotspot = hotspots[splide.index];
                            if (hotspot) {
                                if (current) {
                                    current.classList.remove('active-hotspot');
                                }
                                hotspot.classList.add('active-hotspot');
                                current = hotspot;
                            }
                        });
                    }
                    if (configs.cardHover) {
                        let cardImage = document.getElementById(configs.cardHover);
                        if (window.innerWidth > 1024) {
                            cardImage.addEventListener('mousemove', function (e) {
                                let left = e.offsetX;
                                let width = cardImage.getBoundingClientRect().width;
                                let spacing = left / width;
                                let index = Math.floor(spacing * configs.maxSlide);
                                splide.go(index);
                            });
                            cardImage.addEventListener('mouseleave', function (e) {
                                splide.go(0);
                            });
                        }
                    }
                    if (configs.progressBar) {
                        var bar = splide.root.querySelector('.splide-progress-bar');
                        splide.on('mounted move', function () {
                            var end = configs.progressBar;
                            if (configs.progressBarHeader) {
                                end = splide.Components.Slides.getLength();
                            }
                            var rate = 100 * (splide.index / end);
                            if (bar) {
                                var widthBar = window.getComputedStyle(bar).getPropertyValue('width').replace("px", '');
                                var widthProgressBar = window.getComputedStyle(bar.closest('.splide-progress')).getPropertyValue('width').replace("px", '');
                                var percentBar = 100 * (Number(widthBar) / Number(widthProgressBar));
                                var rateBar = rate + percentBar;
                                var maxRate = 100 - percentBar;
                                if (rateBar > 100) {
                                    rate = maxRate;
                                }
                                if (document.querySelector('body').classList.contains('rtl')) {
                                    bar.style.marginRight = rate + '%';
                                }
                                else {
                                    bar.style.marginLeft = rate + '%';
                                }
                            }
                        });
                    }
                    if (el.classList.contains('card-product-img')) {
                        splide.on('resized', function () {
                            var height = splide.root.querySelector('.splide__track').offsetHeight;
                            splide.Components.Slides.get().forEach((item) => {
                                item.slide.style.height = height + "px";
                            });
                        });
                    }
                    if (configs.events) {
                        configs.events.forEach((e) => {
                            splide.on(e.event, e.callback);
                        });
                    }
                    el.splide = splide;
                    splide.mount();
                    if (configs.playOnHover) {
                        splide.Components.Autoplay.pause();
                        el.onmouseover = function () {
                            splide.Components.Autoplay.play();
                        };
                        el.onmouseout = function () {
                            splide.Components.Autoplay.pause();
                        };
                    }
                };
                if (!window.Eurus.loadedScript.includes('slider')) {
                    deferScriptLoad('slider', window.Eurus.sliderScript, initSlider, true);
                }
                else if (window.Splide) {
                    initSlider();
                }
                else {
                    document.addEventListener('slider loaded', () => {
                        initSlider();
                    });
                }
            },
            moveThumbnail(index, thumbnail, thumbsRoot, direction) {
                if (thumbnail) {
                    if (direction == 'vertical') {
                        setTimeout(() => {
                            thumbsRoot.scrollTop = (index + 1) * thumbnail.offsetHeight - thumbsRoot.offsetHeight * 0.5 + thumbnail.offsetHeight * 0.5 + index * 12;
                        }, 50);
                    }
                    else {
                        thumbsRoot.scrollLeft = (index - 2) * thumbnail.offsetWidth;
                    }
                }
            }
        });
        // global vars
        Alpine.store('baGlobal', {
            navAccent: 'top',
            headerHeight: 90,
            stickyActive: false,
        }),
            Alpine.data('loadingSplash', () => ({
                splashHide: {
                    [':class']: "loaded && 'opacity-0 pointer-events-none'",
                    [':aria-hidden']: "loaded ? 'true' : 'false'"
                },
                loadingText: {
                    ['x-init']: "$watch('loaded', value => { setTimeout(() => { $el.classList.add('[animation-play-state:paused]'); }, 800); })",
                },
            })),
            Alpine.data('baSection', () => ({
                sectionMakoto: {
                    ['x-data']: "{ active : false }",
                    ['x-intersect:enter.full']: `$store.baGlobal.navAccent = 'makoto';`,
                    ['x-intersect:enter.33%.once']: "active = true",
                },
                sectionSatsuki: {
                    ['x-data']: "{ active : false }",
                    ['x-intersect:enter.full']: `$store.baGlobal.navAccent = 'satsuki';`,
                    ['x-intersect:enter.33%.once']: "active = true",
                },
                sectionIbuki: {
                    ['x-data']: "{ active : false }",
                    ['x-intersect:enter.full']: `$store.baGlobal.navAccent = 'ibuki';`,
                    ['x-intersect:enter.33%.once']: "active = true",
                },
                sectionIroha: {
                    ['x-data']: "{ active : false }",
                    ['x-intersect:enter.full']: `$store.baGlobal.navAccent = 'iroha';`,
                    ['x-intersect:enter.33%.once']: "active = true",
                },
                sectionChiaki: {
                    ['x-data']: "{ active : false }",
                    ['x-intersect:enter.full']: `$store.baGlobal.navAccent = 'chiaki';`,
                    ['x-intersect:enter.33%.once']: "active = true",
                },
                sectionNormal: {
                    ['x-data']: "{ active : false }",
                    ['x-intersect:enter.33%.once']: "active = true",
                },
                sectionNone: {
                    ['x-data']: "{ active : false }",
                    ['x-intersect:enter.full']: `$store.baGlobal.navAccent = "";`,
                    ['x-intersect:enter.33%.once']: "active = true",
                },
                media: {
                    [':class']: "active || 'opacity-0 blur-sm -translate-x-4'",
                },
                mediaRight: {
                    [':class']: "active || 'opacity-0 blur-sm translate-x-4'",
                },
                content: {
                    [':class']: "active || 'opacity-0 translate-y-8 lg:-translate-x-8'",
                },
                contentRight: {
                    [':class']: "active || 'opacity-0 translate-y-8 lg:translate-x-8'",
                },
                btn: {
                    [':class']: "active || 'translate-y-full'",
                },
                fadeUp: {
                    [':class']: "active || 'opacity-0 translate-y-8'",
                },
            })),
            Alpine.data('baHeader', () => ({
                stickyHeader: {
                    [':class']: "$store.baGlobal.stickyActive && 'sticky top-0'",
                },
                headerBind: {
                    ['x-init']: "$store.baGlobal.headerHeight = $el.getBoundingClientRect().height + 10",
                    ['@resize.window.throttle']: "$store.baGlobal.headerHeight = $el.getBoundingClientRect().height + 10",
                    [':class']: "$store.baGlobal.stickyActive && 'motion-safe:animate-(--animate-slide-down)'",
                },
                accentTop: {
                    [':class']: "$store.baGlobal.navAccent == 'top' ? 'bg-top' : 'bg-bottom'"
                },
                navTop: {
                    ['@click.prevent']: "scrollTo({ top: 0 , behavior: 'auto' })",
                },
                navTopMobile: {
                    ['@click.prevent']: "scrollTo({ top: 0 , behavior: 'auto' }); $store.lpMobileNav.close();",
                    [':class']: "$store.lpMobileNav.show || 'opacity-0 -translate-x-1/3'",
                    [':tabindex']: "$store.lpMobileNav.show ? '0' : '-1'",
                },
                navChara: {
                    ['@click.prevent']: "scrollTo({ top: Math.floor(document.querySelector($el.getAttribute('href')).offsetTop - $store.baGlobal.headerHeight) , behavior: 'auto' });",
                },
                navCharaMobile: {
                    ['@click.prevent']: "scrollTo({ top: Math.floor(document.querySelector($el.getAttribute('href')).offsetTop - $store.baGlobal.headerHeight) , behavior: 'auto' }); $store.lpMobileNav.close();",
                    [':class']: "$store.lpMobileNav.show || 'opacity-0 -translate-x-1/3'",
                    [':tabindex']: "$store.lpMobileNav.show ? '0' : '-1'",
                },
                accentMakoto: {
                    [':class']: "$store.baGlobal.navAccent == 'makoto' ? 'bg-top' : 'bg-bottom'"
                },
                accentSatsuki: {
                    [':class']: "$store.baGlobal.navAccent == 'satsuki' ? 'bg-top' : 'bg-bottom'"
                },
                accentIbuki: {
                    [':class']: "$store.baGlobal.navAccent == 'ibuki' ? 'bg-top' : 'bg-bottom'"
                },
                accentIroha: {
                    [':class']: "$store.baGlobal.navAccent == 'iroha' ? 'bg-top' : 'bg-bottom'"
                },
                accentChiaki: {
                    [':class']: "$store.baGlobal.navAccent == 'chiaki' ? 'bg-top' : 'bg-bottom'"
                },
                navLocaleMobile: {
                    [':class']: "$store.lpMobileNav.show || 'opacity-0 -translate-x-1/3'",
                    [':tabindex']: "$store.lpMobileNav.show ? '0' : '-1'",
                },
                navBuyBtn: {
                    [':class']: "$store.lpMobileNav.show || 'translate-y-full'",
                    [':tabindex']: "$store.lpMobileNav.show ? '0' : '-1'",
                },
                mobileNav: {
                    [':class']: "$store.lpMobileNav.show ? 'bg-left backdrop-blur-md opening' : 'opacity-0 pointer-events-none bg-right closing'",
                    [':aria-hidden']: "$store.lpMobileNav.show ? 'false' : 'true'"
                },
                mobileNavFade: {
                    [':class']: "$store.lpMobileNav.show || 'opacity-0'",
                },
                navBtn: {
                    ['@click']: "$store.lpMobileNav.toggle()",
                },
                navHamburger: {
                    ['x-show']: "!$store.lpMobileNav.show",
                },
                navClose: {
                    ['x-show']: "$store.lpMobileNav.show"
                },
            })),
            // kv anim
            Alpine.data('baKv', () => ({
                kvBind: {
                    ['x-intersect:enter']: "$store.baGlobal.navAccent = 'top'",
                    ['x-intersect:enter.full']: "$store.baGlobal.stickyActive = false",
                    ['x-intersect:leave']: "$store.baGlobal.stickyActive = true"
                },
                image: {
                    ['x-effect']: "loaded && $el.classList.remove('translate-x-[-100.5%]')"
                },
                text: {
                    ['x-effect']: "loaded && $el.classList.remove('opacity-0', 'blur-xs')"
                },
            })),
            // mobile nav
            Alpine.store('lpMobileNav', {
                show: false,
                toggle() {
                    this.show = !this.show;
                },
                close() {
                    this.show = false;
                }
            });
    });
});
